export default __webpack_public_path__ + "static/media/023-savannah.b905a51b.svg";